<template>
  <li class="list-inline-item">
    <b-card
      class="mb-2 card-selectable selected"
      no-body
      @click="handleSelection"
    >
      <b-img :src="card.image" height="30" width="30" center rounded></b-img>
    </b-card>
  </li>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  methods: {
    handleSelection() {
      this.$emit('remove-card', this.card);
    },
  },
};
</script>
